import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { GenericValidator } from 'src/app/validation/general-validation';
import { DatePipe } from '@angular/common';
import { ConfirmDialogComponent } from 'src/app/Common/confirm-dialog/confirm-dialog.component';
import { ConfigurationsService } from 'src/app/Service/configurations.service';
import { EditVirtualMeterComponent } from '../edit-virtual-meter/edit-virtual-meter.component';
@Component({
  selector: 'app-virtualconfig-parameter',
  templateUrl: './virtualregisterpanel.html'
})
export class VirtualRegisterpanelComponent implements OnInit {
  isSaveClick: boolean = false;
  IsreadOnly: boolean = false;
  DisplayButton: boolean = false;
  RoleName: string = '';
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;
  displayMessage: { [key: string]: string } = {};
  private ListvalidationMessages: { [key: string]: { [key: string]: string } };
  private ListgenericValidator: GenericValidator;
  ListdisplayMessage: { [key: string]: string } = {};
  RegisterData: [];
  virtualregisterpanelForm: FormGroup;
  ismaxDisable = true;
  registermax: any;
  DropDownList: any;
  errorMsg: string = '';
  successMsg: string = '';
  DatatypeList: [];
  DecimalPointList: [];
  FunctionCodeList: [];
  DecimalPointFrontList: [];
  UserPrefData: any[] = [];
  minSlID: number = 0;
  maxSlID: number = 0;
  SlaveMessage: string = '';
  EnergyMeterdata: any = [];
  listRegisterdata: any;
  flag: boolean = true;
  numberOfRegister: any;
  EnergyMeterID: any;
  PublishRegisterJson: any[] = [];
  MaximumRegister: number = 0;
  MaxRegister: string = '';
  DeviceProtocol: string = '';
  EMIndex: number = 0;
  KeyID: string = '';
  IsChange: boolean = true;
  isSaved: boolean = false;
  ActionList: any[] = [];
  ReqObj: { [key: string]: any } = {};
  RNameObj: { [key: string]: any } = {};
  selectedmetername: any
  selectedmeterid: any
  energyListOfPopup: any = []
  newdata: any;
  Addformulamsg: string;
  isDivVisible: boolean = false
  showvalue: any = false
  ModbusRequestTypeList: any = [];
  devicecounterlist: any = []
  virtualmeterflag: any = false
  selectedslaveid: number;
  UnitList: any = []
  registerDataStore: { [dataId: number]: { tagId: string, formula: string } }
  constructor(public datepipe: DatePipe, public fb: FormBuilder, private GSMConfigService: GSMConfigurationService, private authService: AuthService, private form: FormBuilder, private dialog: MatDialog, public dialogRef: MatDialogRef<VirtualRegisterpanelComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
    this.selectedmetername = data.EnergyMeterdata.selectedmetername
    if (data.EnergyMeterdata.metertype == 2) {
      this.virtualmeterflag = true
    }
    this.devicecounterlist = data.EnergyMeterdata.devicecounterlist
    if (data && data.EnergyMeterdata.RegisterData) {
      this.EnergyMeterdata = data.EnergyMeterdata.RegisterData;
      this.energyListOfPopup = data.EnergyMeterdata.RegisterData.listRegisterdata
    }
    this.Addformulamsg = '*Please first save register data.'
    this.DeviceProtocol = data.EnergyMeterdata.DeviceProtocol;
    this.EnergyMeterID = data.EnergyMeterdata.EMID;
    this.EMIndex = data.EnergyMeterdata.EMIndex;
    this.KeyID = data.EnergyMeterdata.KeyID;

    // Raise Validation message
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.virtualregisterpanelForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });

    this.authService.getValidationMessage().subscribe(resp => {
      this.ListvalidationMessages = resp.listRegisterdata;
      this.ListgenericValidator = new GenericValidator(this.ListvalidationMessages);
    });

  }

  ngOnInit(): void {
    this.isDivVisible = false
    this.virtualregisterpanelForm = this.form.group({
      EnergymeterMasterID: [this.EnergyMeterID],
      SlaveID: ['', [Validators.required]],
      MaxRegisters: ['', [Validators.required]],
      ReadRegisterQuantity: ['', [Validators.required]],
      ModbusRequestType: ['0', [Validators.required]],
      StartRegisterNumber: ['', [Validators.required]],
      'listRegisterdata': this.form.array([this.fb.group({
        RegisterName: ['', [Validators.required]],
        RegisterNO: ['', [Validators.required]],
        DataType: ['', [Validators.required]],
        FunctionCode: ['', [Validators.required]],
        DecimalPoint: ['', [Validators.required]],
        ReadWriteAction: ['', [Validators.required]],
        IsDisplayGraph: [''],
        IsTotalizer: [''],
        HighThresoldValue: [0, [Validators.required]],
        LowThresoldValue: [0, [Validators.required]],
        Unit: ["NONE", Validators.required],
        FullScale: ['', Validators.required],
        Location: ['', Validators.required],
        ZeroScale: ['', Validators.required],
        RegisterSeq: [0],
        RegisterDataId: [0],
        DecimalPointForFront: ['', [Validators.required]],
        IsFromParameterConfig: [''],
        EnergymeterMasterID: [this.EnergyMeterID],
        VirtualRelationdetails: [''],
        TagId: [''],
        Formula: ['']
      })])
    });

    this.Getdropdownlist();
    if (this.EnergyMeterdata != null && this.EnergyMeterID == 0) {
      this.SetRegisterData();
      this.IsChange = true;
      this.isSaved = false;
    }
    else if (this.EnergyMeterID > 0) {
      this.GetRegisterdata(this.EnergyMeterID);
    }
    this.UserPrefData = JSON.parse(localStorage.getItem('UserPref'));
    if (this.UserPrefData) {
      this.minSlID = this.UserPrefData.filter(x => x.PrefKey == 'MinSlaveID')[0].PrefValue;
      this.maxSlID = this.UserPrefData.filter(x => x.PrefKey == 'MaxSlaveID')[0].PrefValue;
      this.MaximumRegister = this.DeviceProtocol == 'HTTP' ? this.UserPrefData.filter(x => x.PrefKey == 'HTTP')[0].PrefValue : this.UserPrefData.filter(x => x.PrefKey == 'FTP')[0].PrefValue;
    }
    this.virtualregisterpanelForm.valueChanges.subscribe(val => {
      if (this.isSaved == true) {
        this.IsChange = true;
      }
       if (this.genericValidator != undefined) {
         this.displayMessage = this.genericValidator.processMessages(this.virtualregisterpanelForm, false, this.validationMessages);
       }
    });

    this.RoleName = localStorage.getItem('RoleName');
  }
  GetRegisterdata(id) {
    if (id != null) {
      this.GSMConfigService.GetRegisterdata(id, 'N', 'N', '').subscribe(
        (result) => {
          if (result != null) {
            this.selectedslaveid = result.SlaveID
            this.EnergyMeterdata = result;
            this.energyListOfPopup = result.listRegisterdata
            this.SetRegisterData();
            this.IsChange = false;
            this.isSaved = true;
          }

          this.selectedmeterid = id
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }
  SetRegisterData() {
    this.flag = false;
    const control = <FormArray>this.virtualregisterpanelForm.controls['listRegisterdata'];
    control.clear();
    if (this.energyListOfPopup) {
      this.energyListOfPopup.forEach((element, i) => {
        if (element?.TagId != "DataCount") {
          control.push(
            this.form.group({
              RegisterName: new FormControl(element?.RegisterName, [Validators.required]),
              RegisterNO: new FormControl(element?.RegisterNO ? element?.RegisterNO : 1, [Validators.required]),
              DataType: new FormControl(element?.DataType ? element?.DataType.toString() : '0', [Validators.required]),
              FunctionCode: new FormControl(element?.FunctionCode.toString() ? element?.FunctionCode.toString() : '1', [Validators.required]),
              DecimalPoint: new FormControl(element?.DecimalPoint ? element?.DecimalPoint.toString() : '0', [Validators.required]),
              ReadWriteAction: new FormControl(element?.ReadWriteAction ? element?.ReadWriteAction.toString() : '0', [Validators.required]),
              IsDisplayGraph: new FormControl(element?.IsDisplayGraph ? (element?.IsDisplayGraph.toString() == 'true') ? true : false : false),
              IsTotalizer: new FormControl(element?.IsTotalizer ? (element?.IsTotalizer.toString() == 'true') ? true : false : false),
              HighThresoldValue: new FormControl(element?.HighThresoldValue ? element?.HighThresoldValue : 0, [Validators.required]),
              LowThresoldValue: new FormControl(element?.LowThresoldValue ? element?.LowThresoldValue : 0, [Validators.required]),
              RegisterSeq: element?.RegisterSeq ? element?.RegisterSeq : 0,
              Unit: new FormControl(element?.Unit ? element?.Unit : "NONE", [Validators.required]),
              ZeroScale: new FormControl(element?.ZeroScale ? element?.ZeroScale : ' ', [Validators.required]),
              Formula: new FormControl(element?.Formula ? element?.Formula : ' ', [Validators.required]),
              TagId: new FormControl(element?.TagId ? element?.TagId : ' ', [Validators.required]),
              VirtualRelationdetails: new FormControl(element?.VirtualRelationdetails ? element?.VirtualRelationdetails : ' ', [Validators.required]),
              EnergymeterMasterID: this.EnergyMeterID,
              FullScale: new FormControl(element?.FullScale ? element?.FullScale : ' ', [Validators.required]),
              Location: new FormControl(element?.Location ? element?.Location : ' ', [Validators.required]),
              RegisterDataId: element?.RegisterDataId,
              DecimalPointForFront: new FormControl(element?.DecimalPointForFront ? element?.DecimalPointForFront.toString() : '0', [Validators.required]),
              IsFromParameterConfig: this.newdata?.IsFromParameterConfig ? this.newdata?.IsFromParameterConfig : element?.IsFromParameterConfig,
              // Formula: element?.Formula,
              // TagId: element?.TagId,
              TempFormula: element?.TempFormula,
              // VirtualRelationdetails: [element.VirtualRelationdetails]


            })
          );
        }
      });

    }
    else {
      control.push(
        this.form.group({
          RegisterName: new FormControl('', [Validators.required]),
          RegisterNO: new FormControl(1, [Validators.required]),
          DataType: new FormControl('0', [Validators.required]),
          FunctionCode: new FormControl('1', [Validators.required]),
          DecimalPoint: new FormControl('0', [Validators.required]),
          ReadWriteAction: new FormControl('0', [Validators.required]),
          IsDisplayGraph: new FormControl(false),
          IsTotalizer: new FormControl(false),
          HighThresoldValue: new FormControl(0, [Validators.required]),
          LowThresoldValue: new FormControl(0, [Validators.required]),
          RegisterSeq: 0,
          Unit: new FormControl("NONE", [Validators.required]),
          FullScale: new FormControl(' ', [Validators.required]),
          Location: new FormControl(' ', [Validators.required]),
          ZeroScale: new FormControl(' ', [Validators.required]),
          Formula: new FormControl(' ', [Validators.required]),
          TagId: new FormControl(' ', [Validators.required]),
          VirtualRelationdetails: new FormControl(' ', [Validators.required]),
          EnergymeterMasterID: this.EnergyMeterID,
          DecimalPointForFront: new FormControl('0', [Validators.required]),
          IsFromParameterConfig: 'N',
        })
      );
    }
    if (this.RoleName == 'PortalAdmin') {
      this.DisplayButton = false;
      this.IsreadOnly = true;
      const control = <FormArray>this.virtualregisterpanelForm.controls['listRegisterdata'];
      // control.disable();
    }
    else {
      this.DisplayButton = true;
      this.IsreadOnly = false;
    }
    this.normalizeUnitValues();
  }

  normalizeUnitValues(): void {
    if (!this.UnitList?.length || !this.virtualregisterpanelForm?.get('listRegisterdata')) {
      return;
    }
    const rows = this.virtualregisterpanelForm.get('listRegisterdata') as FormArray;
    rows.controls.forEach((row: FormGroup) => {
      const unitControl = row.get('Unit');
      const current = unitControl?.value;
      if (current == null || current === '') {
        return;
      }
      const match = this.UnitList.find((item: any) =>
        item.CodeDisplayName === current || String(item.CodeValue) === String(current)
      );
      if (match) {
        unitControl.patchValue(match.CodeDisplayName, { emitEvent: false });
      }
    });
  }


  // call for Getdropdownlist
  Getdropdownlist() {
    let reqpara = 'DataType,FunctionCode,DecimalPoint,ReadWriteAction,DecimalPointForFront,ModbusRequestType,Units';
    this.GSMConfigService.Getdropdownlist(reqpara).subscribe(
      (result) => {
        this.DropDownList = result;
        this.DatatypeList = this.DropDownList['listDataType'];
        this.FunctionCodeList = this.DropDownList['listFunctionCode'];
        this.DecimalPointList = this.DropDownList['listDecimalPoint'];
        this.ActionList = this.DropDownList['listaction'];
        this.DecimalPointFrontList = this.DropDownList['listDecimalPointForFront'];
        this.ModbusRequestTypeList = this.DropDownList['listModbusRequestType'];
        this.UnitList = this.DropDownList['listUnits'] || [];
        this.normalizeUnitValues();
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }
  // on change all dropdown List
  OnChange(type) {
    const control = <FormArray>this.virtualregisterpanelForm.controls['listRegisterdata'];
    var data: any;
    if (control.status == 'INVALID') {
      control.value.forEach((element, i) => {
        var listdata = (this.virtualregisterpanelForm.get('listRegisterdata') as FormArray).at(i);

        if (type == 'dataType') {
          if (control.value[i].DataType == '') {
            listdata.get('DataType').patchValue(control.value[0].DataType);
          }
        }
        if (type == 'FunctionCode') {
          if (control.value[i].FunctionCode == '') {
            listdata.get('FunctionCode').patchValue(control.value[0].FunctionCode);
          }
        }
        if (type == 'DecimalPoint') {
          if (control.value[i].DecimalPoint == '') {
            listdata.get('DecimalPoint').patchValue(control.value[0].DecimalPoint);
          }
        }
        if (type == 'ReadWriteAction') {
          if (control.value[i].ReadWriteAction == '') {
            listdata.get('ReadWriteAction').patchValue(control.value[0].ReadWriteAction);
          }
        }
      });
    }
  }

  OnSubmit() {
    this.isSaveClick = true;
    if (this.virtualregisterpanelForm.get('listRegisterdata').invalid) {
      this.errorMsg = 'Need to fill all fields of Register Data List !!';

      return;
    }
    // if ((this.virtualregisterpanelForm.value.ModbusRequestType == "1") && (this.virtualregisterpanelForm.value.StartRegisterNumber == '' || this.virtualregisterpanelForm.value.ReadRegisterQuantity == '' || this.virtualregisterpanelForm.value.SlaveID == null || this.virtualregisterpanelForm.value.MaxRegisters == null) && this.virtualmeterflag == false) {
    //   this.virtualregisterpanelForm.updateValueAndValidity();
    //   this.virtualregisterpanelForm.markAllAsTouched();

    //   this.displayMessage = this.genericValidator.processMessages(this.virtualregisterpanelForm, true, this.validationMessages);

    //   return;
    // } else if ((this.virtualregisterpanelForm.value.ModbusRequestType == "0") && (this.virtualregisterpanelForm.value.SlaveID == null || this.virtualregisterpanelForm.value.MaxRegisters == null) && this.virtualmeterflag == false) {
    //   this.virtualregisterpanelForm.updateValueAndValidity();
    //   this.virtualregisterpanelForm.markAllAsTouched();

    //   this.displayMessage = this.genericValidator.processMessages(this.virtualregisterpanelForm, true, this.validationMessages);

    //   return;
    // }
    // if ((this.EnergyMeterdata.MaxRegisters) != (this.virtualregisterpanelForm.value.listRegisterdata.length) && this.virtualmeterflag == false) {

    //   this.errorMsg = 'No. of registers in the list should be same as Maximum Register Field !!';
    //   return;
    // }
    if (this.virtualmeterflag == false) {
      this.ValidateFields('Register');
    }
    this.ValidateFields('SlaveID');

    // if ((this.virtualregisterpanelForm.value.ModbusRequestType == "0") && (this.virtualregisterpanelForm.value.ReadRegisterQuantity == '' || this.virtualregisterpanelForm.value.ReadRegisterQuantity != '') && this.virtualmeterflag == false) {

    //   this.virtualregisterpanelForm.value.ReadRegisterQuantity = 0
    // }
    // if ((this.virtualregisterpanelForm.value.ModbusRequestType == "0") && (this.virtualregisterpanelForm.value.StartRegisterNumber == '' || this.virtualregisterpanelForm.value.StartRegisterNumber != '') && this.virtualmeterflag == false) {

    //   this.virtualregisterpanelForm.value.StartRegisterNumber = 0
    // }

    if (!this.virtualregisterpanelForm.value.SlaveID || this.virtualregisterpanelForm.value.SlaveID == null) {
      this.virtualregisterpanelForm.value.SlaveID = 0
    }
    if (!this.virtualregisterpanelForm.value.MaxRegisters || this.virtualregisterpanelForm.value.MaxRegisters == null) {
      this.virtualregisterpanelForm.value.MaxRegisters = this.virtualregisterpanelForm.get('listRegisterdata').value.length
    }
    if (!this.virtualregisterpanelForm.value.ReadRegisterQuantity || this.virtualregisterpanelForm.value.ReadRegisterQuantity == null) {
      this.virtualregisterpanelForm.value.ReadRegisterQuantity = 0
    }
    if (!this.virtualregisterpanelForm.value.ModbusRequestType || this.virtualregisterpanelForm.value.ModbusRequestType == null) {
      this.virtualregisterpanelForm.value.ModbusRequestType = 0
    }
    if (!this.virtualregisterpanelForm.value.StartRegisterNumber || this.virtualregisterpanelForm.value.StartRegisterNumber == null) {
      this.virtualregisterpanelForm.value.StartRegisterNumber = 0
    }
    this.virtualregisterpanelForm.value.listRegisterdata.forEach((data, index) => {
      if (data.VirtualRelationdetails == " ") {
        // Convert empty string to an empty array or null
        this.virtualregisterpanelForm.value.listRegisterdata[index].VirtualRelationdetails = null; // or []
      }
    });
    // if (this.virtualmeterflag == false) {
    // if (this.SlaveMessage == '' && this.MaxRegister == '') {
    let reqparam = { ...this.virtualregisterpanelForm.value };

    if (this.EnergyMeterID > 0) {

      this.SaveRegisterData(reqparam);
    }
    else {
      this.dialogRef.close(reqparam);
    }
    this.IsChange = false;
    // }
    // else {
    //   console.log('main elseee');

    //   return;
    // }
    // }
    // else {
    //   if (this.virtualregisterpanelForm.value.SlaveID != '0' || this.virtualregisterpanelForm.value.SlaveID != 0) {
    //     let reqparam = { ...this.virtualregisterpanelForm.value };
    //     reqparam.MaxRegisters = 1
    //     reqparam.StartRegisterNumber = 0
    //     reqparam.ReadRegisterQuantity = 0

    //     if (this.EnergyMeterID > 0) {
    //       this.SaveRegisterData(reqparam);
    //     }
    //     else {
    //       this.dialogRef.close(reqparam);
    //     }
    //     this.IsChange = false;
    //     // this.dialogRef.close(reqparam);
    //   }
    //   else {
    //     return;
    //   }
    // }
  }

  // Save Register Data
  SaveRegisterData(requestparam) {
    this.errorMsg = '';
    this.successMsg = '';
    this.GSMConfigService.SaveVirtualRegisterData(requestparam).subscribe(
      (result) => {
        if (result) {
          this.successMsg = 'Values Submitted Successfully';
          this.isSaveClick = false;
        }

      },
      (error) => {
        this.errorMsg = error;
      });
  }

  OnCancel() {
    this.dialogRef.close();
  }

  Close() {
    this.dialogRef.close();
  }

  // On Key Press Event
  onKeypressEvent(event, Type) {
    this.ValidateFields(Type);
  }

  // Validate Fields
  ValidateFields(Type) {
    var realValue = '';
    if (Type == 'SlaveID') {
      realValue = this.virtualregisterpanelForm.value.SlaveID;
      if (+realValue > this.maxSlID || +realValue < this.minSlID) {
        this.SlaveMessage = 'Slave ID should be greater than ' + this.minSlID + ' and less than ' + this.maxSlID;
        return;
      }
      else {
        this.SlaveMessage = '';
      }
    }
    else if (Type == 'Register') {
      realValue = this.virtualregisterpanelForm.value.MaxRegisters;
      if (+realValue > this.MaximumRegister) {
        this.MaxRegister = 'Maximum Register should be less than or equal to ' + this.MaximumRegister;
        return;
      }
      else {
        this.MaxRegister = '';
      }
    }
  }

  float2int(value) {
    return value | 0;
  }

  AddNewParameterConfig(ParameterConfigId, index) {

    if (this.data.EnergyMeterdata.EMID == 0) {
      this.isDivVisible = true;
    }
    else {
      var reqObj = {
        RegisterDataId: this.virtualregisterpanelForm['controls'].listRegisterdata['controls'][index]['controls'].RegisterDataId,
        // EnergymeterMasterId: this.meterId,

        TagId: this.virtualregisterpanelForm['controls'].listRegisterdata['controls'][index]['controls'].TagId,
        Formula: this.virtualregisterpanelForm['controls'].listRegisterdata['controls'][index]['controls'].Formula,
        TempFormula: null,
        IsFromParameterConfig: "Y",
        // PCNo: this.ParameterList,


      };
      const dashboardconfig = this.dialog.open(EditVirtualMeterComponent, {
        width: '700px',
        height: '410px',
        disableClose: true,
        data: {
          data: ParameterConfigId, 'selectedmetername': this.selectedmetername, 'id': this.selectedmeterid,
          selectedregister: this.virtualregisterpanelForm['controls'].listRegisterdata['controls'][index]['controls'].RegisterDataId,
          datalist: this.virtualregisterpanelForm['controls'].listRegisterdata['controls'][index]['controls'].VirtualRelationdetails,
          IsForview: 'N', 'otherdata': this.newdata ? this.newdata : reqObj
        }
      })
      dashboardconfig.afterClosed().subscribe(

        (result) => {
          this.virtualregisterpanelForm['controls'].listRegisterdata['controls'][index]['controls'].TagId.patchValue(result.TagId);
          this.virtualregisterpanelForm['controls'].listRegisterdata['controls'][index]['controls'].Formula.patchValue(result.Formula);
          this.virtualregisterpanelForm['controls'].listRegisterdata['controls'][index]['controls'].VirtualRelationdetails.patchValue(result.VirtualRelationdetails);

          this.newdata = result

        }
      );
    }
  }

  DeleteParamterData(event: any, index) {
    this.errorMsg = '';
    this.successMsg = '';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '35%',
      disableClose: true
    })
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result == 'Y') {
          const control = <FormArray>this.virtualregisterpanelForm.controls['listRegisterdata'];
          if (index >= 0) {
            control.removeAt(index);
            this.EnergyMeterdata.MaxRegisters = parseInt(this.EnergyMeterdata.MaxRegisters) - 1
            this.virtualregisterpanelForm.patchValue({
              MaxRegisters: this.EnergyMeterdata.MaxRegisters
            });
          }
        }
      }
    );
  }
  OnAddRegisterData() {
    const control = <FormArray>this.virtualregisterpanelForm.controls['listRegisterdata'];
    // control.clear();
    control.push(
      this.form.group({
        RegisterName: new FormControl('', [Validators.required]),
        RegisterNO: new FormControl(1, [Validators.required]),
        DataType: new FormControl('0', [Validators.required]),
        FunctionCode: new FormControl('1', [Validators.required]),
        DecimalPoint: new FormControl('0', [Validators.required]),
        ReadWriteAction: new FormControl('0', [Validators.required]),
        IsDisplayGraph: new FormControl(false),
        IsTotalizer: new FormControl(false),
        HighThresoldValue: new FormControl(0, [Validators.required]),
        LowThresoldValue: new FormControl(0, [Validators.required]),
        RegisterSeq: 0,
        Unit: new FormControl("NONE", [Validators.required]),
        ZeroScale: new FormControl(1, [Validators.required]),
        VirtualRelationdetails: new FormControl(' ', [Validators.required]),
        TagId: new FormControl(' ', [Validators.required]),
        Formula: new FormControl(' ', [Validators.required]),
        EnergymeterMasterID: this.EnergyMeterID,
        FullScale: new FormControl(1, [Validators.required]),
        Location: new FormControl(' ', [Validators.required]),
        DecimalPointForFront: new FormControl('0', [Validators.required]),
        IsFromParameterConfig: 'N',
      })
    );
  }
}
